<template>
     <UBreadcrumb :items="items" :ui="{
        list: 'flex items-center gap-2 '
      }">
        <template #separator>
          <span class="mx-2 text-muted">/</span>
        </template>
      </UBreadcrumb>
</template>
<script setup lang="ts">
import type { BreadcrumbItem } from '@nuxt/ui'

defineProps<{
  items: BreadcrumbItem[]
}>()
</script>